// tslint:disable
export var ClaimAdjudicationType;
(function (ClaimAdjudicationType) {
    // Regular claim
    ClaimAdjudicationType[ClaimAdjudicationType["Claim"] = 0] = "Claim";
    // Adjustment - change the amount paid to an existing approved claim
    ClaimAdjudicationType[ClaimAdjudicationType["Adjustment"] = 1] = "Adjustment";
    // Reversal - undo an existing approved claim
    ClaimAdjudicationType[ClaimAdjudicationType["Reversal"] = 2] = "Reversal";
})(ClaimAdjudicationType || (ClaimAdjudicationType = {}));
ClaimAdjudicationType['CLAIM'] = 0;
ClaimAdjudicationType['ADJUSTMENT'] = 1;
ClaimAdjudicationType['REVERSAL'] = 2;
//# sourceMappingURL=ClaimAdjudicationType.js.map